import * as joint from '@joint/core'

/**
 * C4 WebBrowser shape - browser window with address bar
 */
export const C4WebBrowser = joint.dia.Element.define(
  'c4.WebBrowser',
  {
    size: { width: 240, height: 180 },
    attrs: {
      frame: {
        refWidth: '100%',
        refHeight: '100%',
        rx: 8,
        ry: 8,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      toolbar: {
        refWidth: '100%',
        height: 30,
        fill: '#2e6295',
        stroke: 'none',
      },
      toolbarRound: {
        refX: 0,
        refY: 0,
        width: '100%',
        height: 38,
        rx: 8,
        ry: 8,
        fill: '#2e6295',
        stroke: 'none',
      },
      addressBar: {
        refX: '10%',
        refY: 8,
        refWidth: '80%',
        height: 14,
        rx: 3,
        ry: 3,
        fill: '#ffffff',
        stroke: 'none',
      },
      buttonRed: {
        refX: 8,
        refY: 11,
        r: 4,
        fill: '#ff5f56',
        stroke: 'none',
      },
      buttonYellow: {
        refX: 20,
        refY: 11,
        r: 4,
        fill: '#ffbd2e',
        stroke: 'none',
      },
      buttonGreen: {
        refX: 32,
        refY: 11,
        r: 4,
        fill: '#27c93f',
        stroke: 'none',
      },
      nameLabel: {
        refX: '50%',
        refY: 60,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: 80,
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Web Browser]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: 110,
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '90%',
          height: 60,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'rect', selector: 'frame' },
      { tagName: 'rect', selector: 'toolbarRound' },
      { tagName: 'rect', selector: 'toolbar' },
      { tagName: 'circle', selector: 'buttonRed' },
      { tagName: 'circle', selector: 'buttonYellow' },
      { tagName: 'circle', selector: 'buttonGreen' },
      { tagName: 'rect', selector: 'addressBar' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createWebBrowser(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Web Browser: ${technology}]` : '[Web Browser]'

  const webBrowser = new C4WebBrowser({
    id,
    position: { x, y },
    attrs: {
      frame: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      toolbar: {
        ...(style?.stroke && { fill: style.stroke }),
      },
      toolbarRound: {
        ...(style?.stroke && { fill: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return webBrowser
}
